// extracted by mini-css-extract-plugin
export default {"ModelContainer":"presenter_ModelContainer__eNLg2","container":"presenter_container__a6gDH"};